"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MACFunctions = void 0;
class MACFunctions {
    constructor() { }
    static isValidMac(mac) {
        if (!mac) {
            return false;
        }
        return this.RE_MAC.test(mac);
    }
    static getByteArrayFromMacAddress(mac) {
        const result = Buffer.alloc(this.MAC_ADDR_LENGTH);
        const macParts = mac.split(/\:|\-/);
        for (let i = 0; i < macParts.length; i++) {
            result[i] = parseInt(macParts[i], 16);
        }
        return result;
    }
    static getMacAddressFromByteArray(byteArray) {
        if (byteArray.length !== MACFunctions.MAC_ADDR_LENGTH) {
            throw new RangeError();
        }
        let result = "";
        for (let i = 0; i < byteArray.length; i++) {
            if (i !== 0) {
                result += ":";
            }
            let hex = byteArray[i].toString(16);
            if (hex.length == 1) {
                hex = "0" + hex;
            }
            result += hex;
        }
        return result;
    }
}
exports.MACFunctions = MACFunctions;
MACFunctions.MAC_ADDR_LENGTH = 6;
MACFunctions.RE_MAC = /^[0-9a-fA-F]{1,2}(?::[0-9a-fA-F]{1,2}){5}$/;
//# sourceMappingURL=MACFunctions.js.map